<template>
    <v-container :class="data.class">
        <h4 class="text-h4 my-3" v-if="data.title">{{ data.title }}</h4>
        <GoogleMap 
            :api-key="$env.VITE_GOOGLE_MAPS_API_KEY" 
            class="mymap" 
            :center="data.map.center" 
            :zoom="data.zoom"
            :styles="mapOption.styles"
            :streetViewControl="mapOption.streetViewControl"
            :zoomControl="mapOption.zoomControl"
            :mapTypeControl="mapOption.mapTypeControl"
            :fullscreenControl="mapOption.fullscreenControl"
            >
            <Marker role="mappin" :title="data.map.center.address" :id="data.map.center.address" :options="{position: data.map.center, icon: markerIcon }" />
        </GoogleMap>
        <p class="my-3">
            <a target="_blank" :href="'https://www.google.com/maps/place/'+data.map.center.lat+','+data.map.center.lng" class="text-white ">
                <v-icon color="white" class="me-2">mdi-google-maps</v-icon>{{ data.map.center.address }}
            </a>
        </p>
        <v-progress-linear  
            id="dividerprogressbar-map" 
            title="dividerprogressbar-map" 
            role="progressbar"
            height="1" 
            color="primary" 
            model-value="100">
        </v-progress-linear>
    </v-container>
</template>

<script>
import mapStyle from "@/plugins/mapStyle.json"
import { GoogleMap, Marker } from "vue3-google-map";
// https://github.com/inocan-group/vue3-google-map/blob/c49f8d9d782d7e264c145f066446d1de15f60732/src/components/GoogleMap.vue#L36
export default{
    components:{GoogleMap, Marker},
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
    data: () => ({
       
        markerIcon: {
            url: '/map-pin.png',
            scaledSize: {width: 24, height: 34},
        },
        mapOption:{
               zoomControl: false,
               draggable: true,
               mapTypeControl: false,
               moveCamera: false,
               scaleControl: false,
               streetViewControl: false,
               rotateControl: false,
               fullscreenControl: false,
               disableDefaultUI: true,
               styles:mapStyle
          }
    })
}
</script>

<style scoped>
.mymap{
    width: 100%;
    height: 450px;
}
</style>